export default function cobranca(podeAcessar, authUserInfo) {
  return [
    {
      name: 'Inicio',
      icon: 'fa fa-th-large fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/cob/inicio',
    },
    {
      name: 'Devedores',
      icon: 'fa fa-user fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cad_devedor_v'),
      link: '/app/cob/devedores',
    },
    {
      name: 'Acionar (Minha Carteira)',
      icon: 'fa fa-phone fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cob_acionar'),
      link: '/app/cob/acionar',
    },
    {
      name: 'Agenda de Retornos',
      icon: 'fa fa-calendar-check-o fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cob_agenda_ret'),
      link: '/app/cob/agenda',
    },
    {
      name: 'Acordos Programados',
      icon: 'fa fa-handshake-o fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cob_acordos_prog'),
      link: '/app/cob/acordo',
    },
    {
      name: 'Instruções Online',
      icon: 'fa fa-commenting-o fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('instrucao_online'),
      link: '/app/cob/instrucao-online',
    },
    {
      name: 'Mensagens',
      icon: 'fa fa-comments fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('mensagens.colab'),
      link: '/app/cob/mensagens',
    },
    {
      name: 'Diversos',
      icon: 'fa fa-star fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: !(
        podeAcessar('cob_comissao') == false &&
        podeAcessar('cob_boletos') == false &&
        podeAcessar('cob_pix') == false &&
        podeAcessar('cob_historicos') == false &&
        podeAcessar('cob_acordos_lib') == false &&
        podeAcessar('cob_recident') == false
      ),
      children: [
        {
          name:
            authUserInfo?.codemp == 'fc65cb' &&
            authUserInfo?.perfil == 'COMERCIAL'
              ? 'Bonificações'
              : 'Comissões',
          type: 'item',
          ativo: podeAcessar('cob_comissao'),
          link: '/app/cob/relatorio-comissao',
        },
        {
          name: 'Boletos Emitidos',
          type: 'item',
          ativo: podeAcessar('cob_boletos'),
          link: '/app/cob/boletos',
        },
        {
          name: 'Pix QrCode',
          type: 'item',
          ativo: podeAcessar('cob_pix'),
          link: '/app/cob/pix',
        },
        {
          name: 'Históricos/Ocorrências',
          type: 'item',
          ativo: podeAcessar('cob_historicos'),
          link: '/app/cob/ocorrencias',
        },
        {
          name: 'Acordos Liberados',
          type: 'item',
          ativo: podeAcessar('cob_acordos_lib'),
          link: '/app/cob/acordos-liberados',
        },
        {
          name: 'Propostas Realizadas',
          type: 'item',
          ativo: podeAcessar('cob_propostas'),
          link: '/app/cob/propostas-realizadas',
        },
        {
          name: 'Receb. à Identificar',
          type: 'item',
          ativo: podeAcessar('cob_recident'),
          link: '/app/cob/bloqueados-identificar',
        },
        {
          name: 'Modelos de Ocorrências',
          type: 'item',
          ativo: podeAcessar('cob_modelo_oco'),
          link: '/app/cob/modelos-ocorrencias',
        },
      ],
    },
  ];
}
